/* eslint-disable jsx-a11y/anchor-is-valid */
import secondaryComponents from "../../../../../../components/secondaryComponents";
import primaryComponents from "../../../../../../components/primaryComponents";
import globalStyles from "../../../../../../assets/styles/base/globalPage.module.scss";
import { useRestockLogs } from "./useRestockLogs";
import { RestockLogsTable } from "../../../../../../components/secondaryComponents/Restocks";

const ReStockLogs = () => {
  const {
    isFetchingStockHistory,
    storeList,
    currentStore,
    metaDetails,
    stockHistory,
    search,
    filterByDate,
    handleFetchStockHistory,
    filterByStoreId,
    gotoPage,
    filterBySearch,
    filterByStockTpye,
  } = useRestockLogs();

  return (
    <div className={`${globalStyles.pageColumnGaps}`}>
      {/* <div className={globalStyles.pageHeaders}>
            <p>{stockHistory?.length} Restock</p>
          </div> */}

      <div className={globalStyles.tableWrapper}>
        <div className={globalStyles.tableHeader}>
          <primaryComponents.SearchField
            classNames={globalStyles.searchField}
            placeholder="Search by Invoice ID, or Supplier"
            trigger={(value) => filterBySearch(value)}
            value={search.get("query") || ""}
            triggerOnInput={true}
            showsearchBtn={true}
          />

          <div className="ml-auto" style={{ width: "160px" }}>
            <primaryComponents.SelectField
              options={[{ name: "All stores", id: null }, ...storeList]}
              idKey="id"
              nameKey="name"
              onChange={filterByStoreId}
              value={
                storeList?.find(
                  (storeItem) => `${storeItem?.id}` === `${currentStore}`,
                )?.name || "Filter store"
              }
              floatError={false}
              classNames="store-select"
            />
          </div>
          <div style={{ width: "170px" }}>
            <primaryComponents.SelectField
              options={[
                { name: "All type", id: null },
                { name: "Bulk Restock", id: "BULK" },
                { name: "Single Restock", id: "SINGLE" },
                { name: "Goods Received", id: "GOODS_RECEIVED" },
              ]}
              idKey="id"
              nameKey="name"
              onChange={filterByStockTpye}
              value={"Filter type"}
              floatError={false}
            />
          </div>

          <primaryComponents.DateRangeInput
            startDate={search.get("start_date")}
            endDate={search.get("end_date")}
            onChange={filterByDate}
            classNames=""
          />
        </div>
        <secondaryComponents.LoaderHelper
          isLoading={isFetchingStockHistory}
          classNames="mt-5"
        >
          <RestockLogsTable
            metaDetails={metaDetails}
            stockHistory={stockHistory}
            handleFetchStockHistory={handleFetchStockHistory}
            gotoPage={gotoPage}
          />
        </secondaryComponents.LoaderHelper>
      </div>
    </div>
  );
};

export default ReStockLogs;
